import { downloaderFiles } from '../utility';
import { http } from './http';

const baseUrl = '/rollout/api/emails_by_status_import';

export const importGrouperEmailsByStatus = async ({ subproject, file }) => {
    const config = {
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    const formData = new FormData();
    formData.append('file_upload', file);
    formData.append('subproject', subproject);

    return http.post(`${baseUrl}/importer/`, formData, config).then((response) => response.data);
};
export const downloadGrouperEmailByStatusTemplate = async (subprojectId, subprojectName) => {
    return http
        .get(`${baseUrl}/${subprojectId}/download_template/`, {
            responseType: 'blob',
        })
        .then((response) => {
            downloaderFiles(response.data, `${subprojectName}.xlsx`);
            return response;
        })
        .catch((error) => error);
};
const service = {
    importGrouperEmailsByStatus,
    downloadGrouperEmailByStatusTemplate,
};
export default service;
